//
// 开关
// ============================================================
import Message from "./message";

let uploadingInit = options => {
    let multiple = options.isMultiple == true ? "multiple" : "";

    let defaultSrc = "";
    let createDefault = src => {
        return `
            <li>
                <div class="uploading-show" style="background: url(` + src + `) center no-repeat" data-src="`+ src +`">
                    <i title="点击删除" class="iconfont icon-roundclose uploading-delete"></i>
                    <div class="uploading-load"></div>
                </div>
            </li>
        `
    };

    if(options.defaultSrc) {
        if(typeof options.defaultSrc == "string") {
            defaultSrc = createDefault(options.defaultSrc);
        }else {

            Ns.each(options.defaultSrc, src => {
                defaultSrc += createDefault(src);
            });
        }
    }



    let str = `
        <div class="uploading-wrapper">
            <ul class="uploading-list">
                `+ defaultSrc +`
                <li>
                    <div title="点击上传" class="uploading-img">
                        <i class="iconfont icon-addimg"></i>
                        <input type="file" ` + multiple + ` class="input-file">
                    </div>
                </li>
            </ul>
        </div>
    `;

    return str;

};
let result = [];

const Uploading = options => {
    new Ns({
        el: options.el,
        eventHandle: {
            type: "click",
            entrust: ".uploading-delete",
            callback:  function (ev) {
                ns(this).parents("li").remove();
                return true;
            }
        },
        load (ev) {
            ns(this).html(uploadingInit(options))
        }
    });
    return new Ns({
        el: ".input-file",
        eventHandle: {
            type: "change",
            callback:  function (ev) {
                Ns.each(ns(options.el).get(), el => {
                    if(el == ns(this).parents(".uploading-wrapper").parent().get(0)) {
                        Ns.each(this.files, file => {

                            let fileSize = file.size;
                            let optionsFileSize = options.fileSize ? options.fileSize : 5;
                            let fileType = file.type != "" ? file.type.substr(0,5) : "";
                            let fileReader = new FileReader();

                            if(fileSize > 1024 * 1024 * optionsFileSize) {
                                Message({
                                    execute: "auto",
                                    status: "danger",
                                    text: "上传文件不能超过" + options.fileSize + "M",
                                });

                            }else {

                                if(fileType == "image") {
                                    fileReader.readAsDataURL(file);

                                    fileReader.onload = ev => {
                                        let url = ev.target.result;
                                        if (options.isMultiple == true || (options.isMultiple != true && ns(this).parents(".uploading-list").find(".uploading-show").length() == 0)) {
                                            let str = `
                                    <li>
                                        <div class="uploading-show" style="background: url(` + url + `) center no-repeat" data-src="`+ url +`">
                                            <i title="点击删除" class="iconfont icon-roundclose uploading-delete"></i>
                                            <div class="uploading-load"></div>
                                        </div>
                                    </li>
                                `;
                                            ns(this).parents("li").before(str);
                                        }

                                        if (options.isMultiple != true) {
                                            ns(this).parents(".uploading-list").find(".uploading-show").css("background", "url(" + url + ") center no-repeat").attr("data-src", url);
                                        }
                                    };
                                }else {
                                    Message({
                                        execute: "auto",
                                        status: "danger",
                                        text: "上传文件格式不对，请重新上传",
                                    });
                                }

                            }

                        });
                    }
                });
                return true;
            }
        },
    });
};

module.exports = Uploading;


// WEBPACK FOOTER //
// src/js/uploading.js